import React from "react";

export default function PageHeader({ title, description, actions, eyebrow }) {
  return (
    <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4 mb-7">
      <div className="space-y-1.5 min-w-0">
        {eyebrow && <div className="ds-overline">{eyebrow}</div>}
        <h1
          className="text-3xl md:text-[34px] font-semibold tracking-tight leading-tight"
          style={{fontFamily:"'Outfit',sans-serif"}}
          data-testid="page-title"
        >
          {title}
        </h1>
        {description && (
          <p className="text-[hsl(var(--text-secondary))] text-sm md:text-base max-w-2xl">
            {description}
          </p>
        )}
      </div>
      {actions && <div className="flex items-center gap-2 shrink-0">{actions}</div>}
    </div>
  );
}
